import { render, staticRenderFns } from "./DialogPC.vue?vue&type=template&id=29367862&scoped=true&"
import script from "./DialogPC.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DialogPC.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./DialogPC.vue?vue&type=style&index=0&id=29367862&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29367862",
  null
  
)

export default component.exports